import { Card, CardBody, CardFooter } from "reactstrap";
import {
  DiscountIcon,
  DiscountLargeIcon,
} from "../../assets/designedPickedIcons";
import moment from "moment";
import { useTranslation } from "../../languages";

const DiscountCard = ({ times, description, name }) => {
  const { t } = useTranslation();
  return (
    <Card className="discount-card mb-4">
      <CardBody>
        <h4 className="f-5 mb-2">
          {name} ({t("resturant")})
        </h4>
        {times?.map((item, index) => (
          <div className="d-flex gap-2 align-items-center">
            <DiscountLargeIcon />
            <h5 className="f-4 m-0 color-primary-red-1">
              {t("discountOn")} {item?.day}
            </h5>
            <small className="color-primary-black-3">
              {moment(item?.startDate).format("DD MMMM YYYY")}
            </small>

            <CardFooter className="border-none f-6 bg-transparent text-end">
              {t("from")} {moment(item?.startTime, "HH:mm").format("hh:mm A")} -{" "}
              {t("to")} {moment(item?.endTime, "HH:mm").format("hh:mm A")}
            </CardFooter>
          </div>
        ))}
        <p className="color-primary-black-3 my-1 mx-3">{description}</p>
      </CardBody>
    </Card>
  );
};

export default DiscountCard;
